<template>
  <div class="equipmentauthorization pointer">
    <div class="navBar">
      <div class="fanhuiBox" @click="fanhui()">
        <img class="fanhui" src="@/assets/icons/fanhui.png" alt="" />
      </div>
      <div class="title">
        <p>云手机授权</p>
      </div>
      <div class="navBtn" @click="toAuthorizeRecord">授权记录</div>
    </div>
    <div class="main">
      <div class="card" @click="toSelectionInstance">
        <p>选择授权云手机</p>
        <span
          ><span class="deviceType">{{
            getDeviceType(authorizeObj.vipCode, authorizeObj.deviceVersionCode)
          }}</span>
          {{ authorizeObj.instanceName }}</span
        >
        <img src="../../../assets/icons/xuenze.png" alt="" />
      </div>
      <div class="sq_zh">
        <p>指定被授权手机号或ID：</p>
        <van-cell-group>
          <van-field
            v-model="phone"
            type="tel"
            placeholder="请输入被授权手机号或ID"
            maxlength="11"
            class="inputBack"
          />
        </van-cell-group>
      </div>
      <div class="sq_zh">
        <p>
          <van-radio-group v-model="Switchlogin" direction="horizontal">
            <van-radio checked-color="#8572eb" :name="false"
              >密码验证</van-radio
            >
            <van-radio checked-color="#8572eb" :name="true">短信验证</van-radio>
          </van-radio-group>
        </p>
        <van-cell-group v-if="Switchlogin">
          <van-field
            v-model="yanzhengma"
            placeholder="请输入验证码"
            maxlength="6"
            class="inputBack"
          >
            <template #button>
              <van-button
                v-if="!yzm_daojishi"
                size="small"
                class="yzm_btn"
                @click="getyanzhengma"
                >获取验证码</van-button
              >
              <van-button v-else size="small" class="yzm_btns" :disabled="true"
                >{{ countDown }}S重新发送</van-button
              >
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-else>
          <van-field
            v-model="password"
            :type="showornot"
            name="密码"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
            class="inputBack"
          >
            <template #button>
              <span @click="isShow">
                <van-icon name="closed-eye" v-if="showeye" />
                <van-icon name="eye-o" v-else />
              </span>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="accreditTime">
        <p>授权时间</p>
        <div class="accreditTimeRight">
          <div class="astrictMax">
            {{
              steppervalMax
                ? `最大授权时间：${steppervalMax}小时`
                : "请先选择授权云手机"
            }}
          </div>
          <div class="operateStepper" v-if="steppervalMax">
            <van-stepper
              v-model="stepperval"
              :max="steppervalMax"
              :min="1"
              :integer="true"
            />
            <span>小时</span>
          </div>
        </div>
      </div>
      <div class="card">
        <van-checkbox
          v-model="checked"
          checked-color="#8572eb"
          icon-size="16px"
          class="agreementBox"
        >
          我已阅读并同意
          <a href="http://static.aixunliu.com/app/auth_agreement.html"
            >《迅流云手机授权协议》</a
          >
        </van-checkbox>
      </div>
      <div class="sq_gz">
        <p class="gz_title">温馨提示：</p>
        <div class="gz_particulars">
          <p>
            1、请合理且合法使用云手机授权功能，切勿将云手机授权给自己所属账号以外的他人账号，避免造成云手机数据丢失、账号盗用等信息安全风险；
          </p>
          <p>
            2、被授权的账号将获取该台设备的操作、控制和观看权限，如若授权不当，可能会导致你在运行游戏、应用的过程时，被他人观看、控制或操作重启和恢复出厂等行为；
          </p>
          <p>
            3、授权过程中存在账号被盗取等相关风险，本公司不承担因授权发生的任何安全责任，请谨慎使用该功能；
          </p>
          <p>4、授权方与被授权方可以随时取消授权关系；</p>
          <p>5、当云手机剩余时间少于24小时，则不能对该云手机进行授权操作。</p>
          <p>6、每台云手机授权无次数限制。</p>
        </div>
      </div>
    </div>
    <div class="baseBox">
      <button class="qdsq_btn" @click="querenshouquan">确认授权</button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getsendCode } from "@/api/login";
import { authorize } from "@/api/instance";
import { mapState, mapMutations } from "vuex";
import buyCode from "@/utils/buyCode";
export default {
  name: "Equipmentauthorization",
  components: {},
  data() {
    return {
      stepperval: 1,
      checked: false,
      phone: "",
      timer: null, // 定时器
      countDown: 60, // 倒计时时间
      yanzhengma: "",
      password: "",
      yzm_daojishi: false,
      userdata: {},
      active: 0,
      Switchlogin: false,
      showornot: "password",
      showeye: true,
      steppervalMax: 0,
    };
  },

  mounted() {
    this.userdata = JSON.parse(localStorage.getItem("data"));
    if (this.authorizeObj.timeRemaining) {
      this.stepperval = this.$common.convertTime(
        this.authorizeObj.timeRemaining
      );
      this.steppervalMax = this.stepperval;
    }
  },
  computed: {
    ...mapState("common", ["authorizeObj"]),
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode) {
          let item = buyCode.deviceIconOptions.find(
            (item) =>
              item.vipCode == vipCode &&
              item.deviceVersionCode == deviceVersionCode
          );
          if (item) {
            return item.deviceType;
          } else {
            if (deviceVersionCode) {
              return `定制${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
  beforeDestroy() {
    this.SET_AUTHORIZEOBJ({});
  },
  methods: {
    ...mapMutations("common", ["SET_AUTHORIZEOBJ"]),
    fanhui() {
      this.$router.go(-1);
    },
    // 获取授权验证码
    async getyanzhengma() {
      let data = {
        mobile: this.userdata.phoneNumber,
        businessType: "authorize",
      };
      await getsendCode(data).then((res) => {
        if (res.code == 200) {
          this.yzm_daojishi = true;
          this.startCountDown();
          Toast("验证码已发送至您的手机");
        } else {
          Toast(res.msg);
        }
      });
    },
    // 验证码倒计时
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timer);
          this.yzm_daojishi = false;
          this.countDown = 60;
        }
      }, 1000);
    },
    // 确认授权
    async querenshouquan() {
      if (!this.authorizeObj.id) {
        Toast("请选择要转移的设备");
        return;
      }
      if (this.phone == "") {
        Toast("被授权人账号不能为空");
        return;
      }
      if (!this.checked) {
        Toast("请阅读并同意《迅流云手机授权协议》");
        return;
      }
      let data = {
        ids: [this.authorizeObj.id],
        accountNumber: this.phone,
        time: this.stepperval,
      };
      if (this.Switchlogin) {
        data.code = this.yanzhengma;
      } else {
        data.password = this.password;
      }
      await authorize(data).then((res) => {
        if (res.code == 200) {
          Toast("授权成功！");
          this.$router.go(-1);
        }
      });
    },
    //密码可见
    isShow() {
      //点击切换眼睛
      this.showeye = !this.showeye;
      if (this.showeye === true) {
        this.showornot = "password";
      } else {
        this.showornot = "text";
      }
    },
    toSelectionInstance() {
      this.$router.push("/selectionInstance");
    },
    toAuthorizeRecord() {
      this.$router.push("/authorizationrecord");
    },
  },
};
</script>

<style lang="less" scoped>
.equipmentauthorization {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 10px 16px 16px 16px;
  .card {
    height: 56px;
    background: #ffffff;
    padding: 0 16px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    margin-bottom: 16px;
    .agreementBox {
      // margin-top: 42px;
      /deep/.van-checkbox__label {
        font-size: 14px !important;
        color: #303030 !important;
        margin-left: 5px;
        margin-top: -2px;
        a {
          color: #886df3 !important;
        }
      }
    }

    p {
      flex: 1;
      text-align: left;
      font-size: 15px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #4a4a4a;
    }
    span {
      height: 22px;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      margin-left: 8px;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
  .accreditTime {
    background: #ffffff;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    margin-bottom: 16px;
    .accreditTimeRight {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .astrictMax {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 8px;
    }
    .operateStepper {
      display: flex;
      align-items: center;
    }
  }
  .sq_zh {
    margin: 16px 0;
    background: #ffffff;
    padding: 16px;
    border-radius: 10px 10px 10px 10px;
    text-align: left;
    .inputBack {
      background-color: #f4f4f4;
      border-radius: 40px;
    }
    p {
      margin-top: 0;
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      span {
        flex: 1;
      }
      .yzmbtn {
        width: 108px;
        height: 30px;
        background: rgb(0, 102, 255);
        border-radius: 15px;
        color: rgb(255, 255, 255);
        font-family: PingFang SC;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0px;
        text-align: center;
        border: none;
      }
      .yzm_btns {
        border: none;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        background: none;
        color: #999999;
      }
    }
  }
  .sq_gz {
    text-align: left;
    .gz_title {
      font-size: 15px;
      color: #a6a6a6;
      margin: 0 0 14px 0;
    }
    .gz_particulars {
      font-size: 11px;
      color: #a6a6a6;
      p {
        margin: 5px 0;
      }
    }
  }
  .qdsq {
    margin-top: 20px;
    .btn {
      margin: 0 auto;
      width: 249px;
      height: 40px;
      border: none;
      background: linear-gradient(
        180deg,
        rgb(95, 144, 250) 0.318%,
        rgb(20, 93, 250) 100%
      );
      border-radius: 4px;
      color: rgb(255, 255, 255);
      font-family: 思源黑体;
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
      letter-spacing: 0px;
      text-align: center;
    }
  }
}
.navBar {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fanhuiBox {
    height: 100%;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fanhui {
      width: 17px;
      height: 17px;
    }
  }
  .title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 600;
    font-size: 17px;
  }
  .navBtn {
    margin-right: 12px;
    color: #886df3;
  }
}

.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .qdsq_btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
/deep/ .van-hairline--top-bottom::after {
  border: none;
}
/deep/.van-cell {
  background: rgba(20, 93, 250, 0.06);
  border-radius: 8px;
}
/deep/.van-field__body {
  height: 30px;
}
</style>